import React, { useEffect, useState } from 'react';
import { Form, Typography, Select, Col, Row, message, List } from 'antd';
import GenericModal from '../../../buttons/genericModal';
import { backendDeleteWithoutRefresh } from '../../../../helpers/callBackend';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const { Option } = Select;

function MergeEntitiesModal(props) {
	const [submitting, setSubmitting] = useState(false);
	const [mergeEntities, setMergeEntities] = useState([])

	useEffect(() => {
		setMergeEntities(props.selectedRows.map(entityRow => ({
			entityId: entityRow.id,
			entityName: entityRow.name,
			bankingEnabled: entityRow.entity?.entity_info?.is_complete
		})))
	}, [props.selectedRows])

	const onFormSubmitModal = (values) => {
		if (mergeEntities.length < 2) {
			message.error("Please select at least two entities.");
			return;
		}
		const bankingEnabledEntities = mergeEntities.filter(entity => entity.bankingEnabled);
		if (bankingEnabledEntities.length > 0) {
			message.error("Please remove the banking enabled entities.");
			return;
		}
		let data = {
			merge_entity_ids: mergeEntities.map(entity => entity.entityId),
			entity_id: values.entity_id,
		};
		setSubmitting(true);
		backendDeleteWithoutRefresh("api/entity/bank-account/relation/", data)
		.then((res) => {
			setSubmitting(false);
			props.mergeEntities(data.merge_entity_ids, data.entity_id);
			props.handleCancelModal();
		}).catch((err) => {
			setSubmitting(false);
			console.error(err);
		})
	};

	return (
		<GenericModal
			size='md'
			visible={props.visible}
			handleCancelModal={() => props.handleCancelModal()}
			showModal={() => props.handleShowModal()}
			modalTitle="Merge Entities"
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>
					<Typography.Text strong>
						Merge the following entities into one.
					</Typography.Text>

					<Row justify="center">
						<Col span={20}>
							<List
								itemLayout="horizontal"
								dataSource={mergeEntities}
								renderItem={(item) => (
									<List.Item>
										<Col span={12}>{item.entityName}</Col>
										<Col span={6}>
											{item.bankingEnabled && <>
												<Typography.Text type="secondary" style={{ fontSize: '10px' }} italic>
													Banking Enabled entity, please remove.
												</Typography.Text>
											</>}
										</Col>
										<Col span={6} align="right">
											<Button 
												disableElevation fullWidth size="small" variant="outlined" color="secondary"
                                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
												onClick={() => {
													setMergeEntities(mergeEntities.filter(entity => entity.entityId != item.entityId))
												}}
											>
												Remove
											</Button>
										</Col>
									</List.Item>
								)
								}
							/>
						</Col>
					</Row>

					<Typography.Text strong>
						Select one entity to be associated with the group's associated bank accounts.
					</Typography.Text>

					<Form.Item
						name="entity_id"
						rules={[
							{
								required: true,
								message: "Please select an entity",
							},
						]}
					>
						<Select
							showSearch
							placeholder="Select an entity"
							optionFilterProp="children"
							disabled={mergeEntities.length === 0}
							filterOption={(input, option) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
						>
							{mergeEntities.map((entity) => (
								<Option value={entity.entityId}>{entity.entityName}</Option>
							))}
						</Select>
					</Form.Item>


					<Typography.Text type="secondary" italic>
						Note: You cannot merge any banking enabled entities.
					</Typography.Text>

					<Form.Item>
						<LoadingButton
							htmlType="submit"
							loading={submitting} loadingPosition="start"
							style={{ margin: "3px", width: "100%" }}
							disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
							sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
						>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	)
}

export default MergeEntitiesModal;